import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import img3 from "../sliderimage/image copy.png";
import img6 from "../sliderimage/image5.jpeg";
// import img6 from "../sliderimage/sliderimg18.jpeg";
import img8 from "../sliderimage/slider2img.jpg";
import img10 from "../sliderimage/funding_img_Improved.jpg";
// import img8 from "../sliderimage/sliderimage3.jpg";

const slides = [
  {
    src: img6,
    subtitle: "Building the Deep-Tech Ecosystem",
    title: "Innovate. Incubate. Scale.",
    description: "Join IIT Ropar's ecosystem to transform your research into a market-ready venture.",
  },
  {
    src: img8,
    subtitle: "Comprehensive Incubation Support",
    title: "From Idea to Enterprise",
    description: "Get access to 20,000 sq. ft. of lab space, prototyping facilities, and a network of 180+ industry mentors.",
  },
  {
    src: img10,
    subtitle: "Fueling Your Growth",
    title: "Funding & Investment",
    description: "Connect with top VCs, Angel Investors, and government grants. Our startups have raised over ₹300 Cr.",
  },
];

export function CarouselWithContent() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isHovered) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [isHovered]);

  const nextSlide = () => setActiveIndex((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setActiveIndex((prev) => (prev - 1 + slides.length) % slides.length);

  const slide = slides[activeIndex];

  return (
    <>
      <style>{`
        /* Slide-in animation for content changes */
        @keyframes heroFadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .hero-fade { animation: heroFadeUp 0.45s cubic-bezier(0.22,1,0.36,1) both; }
        .hero-fade-d1 { animation-delay: 0.05s; }
        .hero-fade-d2 { animation-delay: 0.12s; }
        .hero-fade-d3 { animation-delay: 0.20s; }
        .hero-fade-d4 { animation-delay: 0.28s; }

        /* Image crossfade */
        .slide-bg {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          transition: opacity 0.8s ease, transform 6s ease;
          will-change: opacity, transform;
        }
        .slide-bg.is-active  { opacity: 1; transform: scale(1.05); }
        .slide-bg.is-hidden  { opacity: 0; transform: scale(1);    }

        /* Desktop: left-to-right gradient overlay */
        .desktop-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to right,
            rgba(8,12,28,0.92) 0%,
            rgba(8,12,28,0.65) 42%,
            rgba(8,12,28,0.15) 68%,
            transparent 100%
          );
        }

        /* Arrow button */
        .hero-arrow {
          width: 44px; height: 44px;
          border-radius: 50%;
          background: rgba(255,255,255,0.1);
          border: 1px solid rgba(255,255,255,0.2);
          color: #fff;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          transition: background 0.2s, border-color 0.2s;
          flex-shrink: 0;
        }
        .hero-arrow:hover { background: #3b82f6; border-color: #3b82f6; }

        /* Dot */
        .hero-dot {
          border: none; padding: 0; cursor: pointer;
          border-radius: 999px; height: 7px;
          transition: width 0.3s ease, background 0.3s ease;
        }
      `}</style>

      {/* ══════════════════════════════════════════════════════
          MOBILE LAYOUT
      ══════════════════════════════════════════════════════ */}
      <div
        className="block md:hidden"
        style={{ paddingTop: 64, background: "#f1f5f9" }}
        onTouchStart={() => setIsHovered(true)}
        onTouchEnd={() => setIsHovered(false)}
      >
        {/* Image strip */}
        <div
          className="relative w-full overflow-hidden"
          style={{ height: 210 }}
        >
          {slides.map((s, i) => (
            <div
              key={i}
              className={`slide-bg ${i === activeIndex ? "is-active" : "is-hidden"}`}
              style={{ backgroundImage: `url(${s.src})` }}
            />
          ))}
          {/* Bottom fade — blends image into the card below */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: "linear-gradient(to bottom, transparent 50%, rgba(241,245,249,0.95) 100%)",
            }}
          />
          {/* Progress bar */}
          <div
            className="absolute bottom-0 left-0 h-0.5 bg-blue-500 transition-all duration-500"
            style={{ width: `${((activeIndex + 1) / slides.length) * 100}%` }}
          />
        </div>

        {/* Content card — sits flush below image, negative margin pulls it up slightly */}
        <div
          style={{
            margin: "0 12px 16px",
            marginTop: -16,
            background: "#ffffff",
            borderRadius: 12,
            boxShadow: "0 4px 24px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)",
            overflow: "hidden",
          }}
        >
          {/* Blue accent bar at top of card */}
          <div style={{ height: 3, background: "linear-gradient(to right, #2563eb, #3b82f6, #60a5fa)" }} />

          <div style={{ padding: "18px 20px 20px" }}>

            {/* Slide indicator pills — top right of card */}
            <div className="flex items-center justify-between mb-3">
              <div className="flex gap-1.5 items-center">
                {slides.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveIndex(i)}
                    aria-label={`Slide ${i + 1}`}
                    className="hero-dot"
                    style={{
                      width: i === activeIndex ? 18 : 6,
                      height: 6,
                      background: i === activeIndex ? "#2563eb" : "#cbd5e1",
                    }}
                  />
                ))}
              </div>
              <span style={{
                fontSize: 10,
                fontWeight: 600,
                color: "#94a3b8",
                letterSpacing: "0.1em",
              }}>
                {String(activeIndex + 1).padStart(2, "0")} / {String(slides.length).padStart(2, "0")}
              </span>
            </div>

            {/* Subtitle */}
            <p
              key={`m-sub-${activeIndex}`}
              className="hero-fade hero-fade-d1"
              style={{
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: "#2563eb",
                marginBottom: 6,
              }}
            >
              {slide.subtitle}
            </p>

            {/* Headline */}
            <h1
              key={`m-title-${activeIndex}`}
              className="hero-fade hero-fade-d2"
              style={{
                fontSize: 22,
                fontWeight: 800,
                letterSpacing: "-0.4px",
                color: "#0f172a",
                lineHeight: 1.2,
                marginBottom: 10,
              }}
            >
              {slide.title}
            </h1>

            {/* Description */}
            <p
              key={`m-desc-${activeIndex}`}
              className="hero-fade hero-fade-d3"
              style={{
                fontSize: 13,
                color: "#64748b",
                lineHeight: 1.6,
                marginBottom: 16,
              }}
            >
              {slide.description}
            </p>

            {/* CTA Buttons */}
            <div
              key={`m-cta-${activeIndex}`}
              className="hero-fade hero-fade-d4 flex gap-2"
            >
              <Link to="https://forms.gle/Fz2pn47EqTscZK4T8" style={{ flex: 1 }}>
                <button
                  className="w-full text-white font-bold flex items-center justify-center gap-1.5 active:scale-95 transition-transform"
                  style={{
                    padding: "11px 14px",
                    fontSize: 13,
                    borderRadius: 7,
                    background: "#2563eb",
                    border: "none",
                    boxShadow: "0 2px 10px rgba(37,99,235,0.35)",
                  }}
                >
                  Apply for Incubation <FaArrowRight size={11} />
                </button>
              </Link>
              <Link to="/portfolio">
                <button
                  className="font-bold active:scale-95 transition-transform"
                  style={{
                    padding: "11px 16px",
                    fontSize: 13,
                    borderRadius: 7,
                    border: "1.5px solid #e2e8f0",
                    background: "#f8fafc",
                    color: "#334155",
                    whiteSpace: "nowrap",
                  }}
                >
                  Portfolio
                </button>
              </Link>
            </div>

          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          DESKTOP LAYOUT  (hidden below md)
          Classic full-bleed hero — unchanged from original
      ══════════════════════════════════════════════════════ */}
      <div
        className="relative hidden md:block overflow-hidden bg-slate-900"
        style={{ height: "92dvh" }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Background slides */}
        {slides.map((s, i) => (
          <div
            key={i}
            className={`slide-bg ${i === activeIndex ? "is-active" : "is-hidden"}`}
            style={{ backgroundImage: `url(${s.src})` }}
          />
        ))}

        {/* Left-to-right gradient overlay */}
        <div className="desktop-overlay" style={{ zIndex: 2 }} />

        {/* Content */}
        <div
          className="absolute inset-0 flex items-center"
          style={{ zIndex: 3 }}
        >
          <div className="pl-16 max-w-3xl">
            {/* Accent line + subtitle */}
            <div className="flex items-center gap-4 mb-5">
              <div
                className="flex-shrink-0 bg-blue-500 rounded-full"
                style={{ width: 3, height: 52 }}
              />
              <p
                key={`d-sub-${activeIndex}`}
                className="hero-fade hero-fade-d1 text-blue-400 font-semibold uppercase tracking-widest"
                style={{ fontSize: 13 }}
              >
                {slide.subtitle}
              </p>
            </div>

            {/* Headline */}
            <h1
              key={`d-title-${activeIndex}`}
              className="hero-fade hero-fade-d2 text-white font-extrabold leading-tight mb-5"
              style={{
                fontSize: "clamp(48px, 5.5vw, 76px)",
                textShadow: "0 2px 24px rgba(0,0,0,0.35)",
              }}
            >
              {slide.title}
            </h1>

            {/* Description */}
            <p
              key={`d-desc-${activeIndex}`}
              className="hero-fade hero-fade-d3 text-gray-300 leading-relaxed mb-8"
              style={{ fontSize: "clamp(15px, 1.5vw, 18px)", maxWidth: 500 }}
            >
              {slide.description}
            </p>

            {/* Buttons */}
            <div
              key={`d-cta-${activeIndex}`}
              className="hero-fade hero-fade-d4 flex items-center gap-4"
            >
              <Link to="https://forms.gle/Fz2pn47EqTscZK4T8">
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white font-bold flex items-center gap-2 transition-all hover:gap-3"
                  style={{
                    padding: "14px 28px", fontSize: 15, borderRadius: 3,
                    boxShadow: "0 4px 24px rgba(37,99,235,0.35)",
                  }}
                >
                  Apply for Incubation <FaArrowRight size={14} />
                </button>
              </Link>
              <Link to="/portfolio">
                <button
                  className="text-white font-bold transition-all hover:bg-white/10"
                  style={{
                    padding: "13px 28px", fontSize: 15, borderRadius: 3,
                    border: "1px solid rgba(255,255,255,0.35)",
                    background: "rgba(255,255,255,0.06)",
                    backdropFilter: "blur(6px)",
                  }}
                >
                  View Portfolio
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* Desktop arrow nav */}
        <div
          className="absolute flex gap-3"
          style={{ bottom: 40, right: 40, zIndex: 4 }}
        >
          <button onClick={prevSlide} className="hero-arrow">
            <FaArrowLeft size={14} />
          </button>
          <button onClick={nextSlide} className="hero-arrow">
            <FaArrowRight size={14} />
          </button>
        </div>

        {/* Progress bar */}
        <div
          className="absolute bottom-0 left-0 h-0.5 bg-blue-500 transition-all duration-500"
          style={{ width: `${((activeIndex + 1) / slides.length) * 100}%`, zIndex: 4 }}
        />
      </div>
    </>
  );
}

export default CarouselWithContent;